import React from 'react';

interface ReplayScoreHeaderProps {
    tTeamName: string;
    ctTeamName: string;
    tScore: number;
    ctScore: number;
    timerDisplay: string;
    isBombPlanted: boolean;
    roundNumber: number;
    tLogo?: string;
    ctLogo?: string;
}

const T_COLOR = '#de9b35';
const CT_COLOR = '#5d79ae';

const LogoOrInitial: React.FC<{ logo?: string; name: string; color: string }> = ({ logo, name, color }) => {
    if (logo) {
        return (
            <img
                src={logo}
                alt=""
                style={{
                    width: 24,
                    height: 24,
                    borderRadius: '50%',
                    objectFit: 'cover',
                    border: `1px solid ${color}`,
                }}
            />
        );
    }
    return (
        <div style={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            backgroundColor: color,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 12,
            fontWeight: 800,
            color: '#000',
            flexShrink: 0,
        }}>
            {name.charAt(0).toUpperCase()}
        </div>
    );
};

const ReplayScoreHeader: React.FC<ReplayScoreHeaderProps> = ({
    tTeamName, ctTeamName, tScore, ctScore,
    timerDisplay, isBombPlanted, roundNumber,
    tLogo, ctLogo,
}) => {
    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 0,
            padding: '6px 16px',
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            borderBottom: '1px solid var(--border-primary, #333)',
            flexShrink: 0,
        }}>
            {/* T side */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                flex: 1,
                minWidth: 0,
                justifyContent: 'flex-end',
            }}>
                <LogoOrInitial logo={tLogo} name={tTeamName} color={T_COLOR} />
                <span style={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: T_COLOR,
                    textTransform: 'uppercase',
                    letterSpacing: 0.5,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}>
                    {tTeamName}
                </span>
            </div>

            {/* Scores + Round + Timer */}
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '0 16px',
                minWidth: 120,
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                }}>
                    <span style={{
                        fontSize: 22,
                        fontWeight: 800,
                        color: T_COLOR,
                        fontFamily: '"Consolas", "Menlo", monospace',
                        minWidth: 20,
                        textAlign: 'right',
                    }}>
                        {tScore}
                    </span>
                    <span style={{
                        fontSize: 16,
                        fontWeight: 600,
                        color: '#555',
                    }}>
                        :
                    </span>
                    <span style={{
                        fontSize: 22,
                        fontWeight: 800,
                        color: CT_COLOR,
                        fontFamily: '"Consolas", "Menlo", monospace',
                        minWidth: 20,
                        textAlign: 'left',
                    }}>
                        {ctScore}
                    </span>
                </div>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    marginTop: -2,
                }}>
                    <span style={{
                        fontSize: 9,
                        fontWeight: 600,
                        color: '#666',
                        textTransform: 'uppercase',
                        letterSpacing: 1,
                    }}>
                        Round {roundNumber}
                    </span>
                    <span style={{
                        fontSize: 9,
                        color: '#555',
                    }}>
                        ·
                    </span>
                    <span style={{
                        fontSize: 12,
                        fontWeight: 700,
                        color: isBombPlanted ? '#f0a030' : '#ccc',
                        fontFamily: '"Consolas", "Menlo", monospace',
                    }}>
                        {timerDisplay}
                    </span>
                </div>
            </div>

            {/* CT side */}
            <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                flex: 1,
                minWidth: 0,
                justifyContent: 'flex-start',
            }}>
                <span style={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: CT_COLOR,
                    textTransform: 'uppercase',
                    letterSpacing: 0.5,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                }}>
                    {ctTeamName}
                </span>
                <LogoOrInitial logo={ctLogo} name={ctTeamName} color={CT_COLOR} />
            </div>
        </div>
    );
};

export default ReplayScoreHeader;
